import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Ticketassign from "../components/Chat&assign/Ticketassign";
import Menu from "../components/Menu/Menu";
import Marquee from "react-fast-marquee";
import { FaRegUserCircle, FaSearchengin } from "react-icons/fa";

import Chatbox from "../components/Chat&assign/Chatbox";
import { toast } from "react-toastify";

function Ticketdashboard() {
  const [ticketNumber, setTicketNumber] = useState("");
  const [popupvalue, setPopupvalue] = useState("");
  const [searchedTicket, setSearchedTicket] = useState("");
  const [ticketFound, setTicketFound] = useState(false);
  const [category, setCategory] = useState("");
  const statusFlow = ["Un Assigned", "Assigned", "Opened", "Hold", "Closed"];
  const getStatusIndex = (status) => {
    return statusFlow.indexOf(status);
  };

  const [tickets, setTickets] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [messages, setMessages] = useState([]);

  const rowsPerPage = 10;
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen1, setIsOpen1] = useState(true);
  const [currentPageOpened, setCurrentPageOpened] = useState(1);
  const [currentPageClosed, setCurrentPageClosed] = useState(1);

  const userDetails = JSON.parse(localStorage.getItem("userdetails"));
  // Separate open and closed tickets
  const openedTickets = tickets.filter((ticket) => ticket.status !== "Closed");
  const closedTickets = tickets.filter((ticket) => ticket.status === "Closed");

  // Role-based filter for opened tickets
  const filteredOpenedTickets = openedTickets.filter((openedTickets) => {
    return userDetails.role === "cmanager"
      ? openedTickets.client_id?.toString() === userDetails.clientid?.toString()
      : true;
  });

  const totalPagesOpened = Math.ceil(
    filteredOpenedTickets.length / rowsPerPage
  );
  const startIndexOpened = (currentPageOpened - 1) * rowsPerPage;
  const currentRowsOpened = filteredOpenedTickets.slice(
    startIndexOpened,
    startIndexOpened + rowsPerPage
  );

  // Role-based filter for closed tickets
  const filteredClosedTickets = closedTickets.filter((closedTickets) => {
    return userDetails.role === "cmanager"
      ? closedTickets.client_id?.toString() === userDetails.clientid?.toString()
      : true;
  });

  const totalPagesClosed = Math.ceil(
    filteredClosedTickets.length / rowsPerPage
  );
  const startIndexClosed = (currentPageClosed - 1) * rowsPerPage;
  const currentRowsClosed = filteredClosedTickets.slice(
    startIndexClosed,
    startIndexClosed + rowsPerPage
  );

  const handleViewClick = (row) => {
    setSelectedRow(row);
    setIsModalOpen(true);
    fetchMessages(row.id);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedRow(null);
    setMessages([]);
  };

  const fetchTickets = async () => {
    try {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/gettickets.php`;
      const response = await fetch(apiUrl, { method: "POST" });
      const result = await response.json();
      if (result.message === "Records fetched successfully") {
        setTickets(result.data);
      }
    } catch (error) {
      console.log("Error fetching tickets:", error);
    }
  };

  useEffect(() => {
    fetchTickets();
  }, []);

  const fetchMessages = async (ticketNumber) => {
    try {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/getmsg.php`;
      const formData = new FormData();
      formData.append("ticket_number", ticketNumber);

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (response.ok && data.message === "Records fetched successfully") {
        setMessages(data.data);
      } else {
        setMessages([]);
      }
    } catch (error) {
      console.error("Error fetching messages:", error);
      setMessages([]);
    }
  };

  const handlereopen = async (ticketId) => {
    try {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/reopen.php`;
      const formData = new FormData();
      formData.append("id", ticketId);

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      if (response.ok && data.message === "Ticket reopened successfully") {
        alert("Ticket reopened successfully");
        fetchTickets();
      } else {
        alert("Failed to reopen ticket");
        console.error(
          "Error reopening ticket:",
          data.message || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error during ticket reopening:", error);
      alert("Error reopening ticket");
    }
  };

  // const [searchedTicket, setSearchedTicket] = useState("");
  // const [chatMessages, setChatMessages] = useState([]);

  const handlestatus = async (status) => {
    // console.log("Ticket status changed to:", status);

    if (!selectedRow || !selectedRow.ticketId) {
      toast.error("No ticket selected.");
      return;
    }

    if (selectedRow.category === "") {
      toast.error("Select the Category before Close or Hold .");
      return;
    }

    try {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/status.php`;
      const formData = new FormData();
      formData.append("id", selectedRow.ticketId);
      formData.append("status", status);
      formData.append("clsid", userDetails.userid);
      formData.append("category", selectedRow.category);

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        toast.success(`Ticket status has been updated to ${status}`);
        fetchTickets(); // refresh list
        closeModal(); // close modal
      } else {
        toast.error(data?.message || "An unexpected error occurred.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("An error occurred while updating the status.");
    }
  };

  const handleTicketTrack = async () => {
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/tickettrack.php`;
    const formData = new FormData();

    formData.append("ticketnumber", ticketNumber);
    formData.append("role", userDetails?.role);

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (
        response.ok &&
        result.message === "Ticketnumber tracked successfully"
      ) {
        if (Array.isArray(result.data) && result.data.length > 0) {
          setSearchedTicket(result.data[0]);
          setTicketFound(true);
        } else {
          setSearchedTicket(null);
          setTicketFound(false);
        }
      } else {
        alert("Ticket not found");
        setTicketFound(false);
      }
    } catch (error) {
      setSearchedTicket(null);
      setTicketFound(false);
    }
  };

  return (
    <div>
      {/* menu box */}
      <div>
        <h1 className="h1">
          {userDetails.role === "admin"
            ? "Admin Portal"
            : userDetails.role === "imanager"
            ? "Support Manager Portal"
            : userDetails.role === "icoordinator"
            ? "Support Co-ordinator Portal"
            : userDetails.role === "cmanager"
            ? "Client Manager Portal"
            : ""}
        </h1>
      </div>
      <div className="center">
        <div className="menu-position">
          <Menu />
          <h2 className="clientname">{userDetails.clientname}</h2>
          <div className="welcome_tag">
            <span>
              <div className="marquee-container">
                <Marquee
                  speed={40}
                  direction="right"
                  pauseOnHover
                  gradient={false}
                >
                  {userDetails.username}
                </Marquee>
              </div>
            </span>
            <div className="profile_icon">
              <FaRegUserCircle />
            </div>
          </div>
        </div>
      </div>

      {/* tickets cards */}
      <div className="ticket-summary">
        <div className="ticket-card">
          <span className="ki">Total Tickets:</span>
          <span className="ki">
            {
              tickets.filter((ticket) =>
                userDetails.role === "cmanager"
                  ? ticket.client_id?.toString() ===
                    userDetails.clientid?.toString()
                  : true
              ).length
            }
          </span>
        </div>
        <div className="ticket-card">
          <span className="ki">UnAssigned Tickets:</span>
          <span className="ki">
            {
              tickets.filter(
                (ticket) =>
                  ticket.status === "Un Assigned" &&
                  (userDetails.role === "cmanager"
                    ? ticket.client_id?.toString() ===
                      userDetails.clientid?.toString()
                    : true) // show all if not cmanager
              ).length
            }
          </span>
        </div>
        <div className="ticket-card">
          <span className="ki">Assigned Tickets:</span>
          <span className="ki">
            {
              tickets.filter(
                (ticket) =>
                  ticket.status === "Assigned" &&
                  (userDetails.role === "cmanager"
                    ? ticket.client_id?.toString() ===
                      userDetails.clientid?.toString()
                    : true)
              ).length
            }
          </span>
        </div>
        <div className="ticket-card">
          <span className="ki">Opened Tickets:</span>
          <span className="ki">
            {
              tickets.filter(
                (ticket) =>
                  ticket.status === "Opened" &&
                  (userDetails.role === "cmanager"
                    ? ticket.client_id?.toString() ===
                      userDetails.clientid?.toString()
                    : true)
              ).length
            }
          </span>
        </div>
        <div className="ticket-card">
          <span className="ki">Hold Tickets:</span>
          <span className="ki">
            {
              tickets.filter(
                (ticket) =>
                  ticket.status === "Hold" &&
                  (userDetails.role === "cmanager"
                    ? ticket.client_id?.toString() ===
                      userDetails.clientid?.toString()
                    : true)
              ).length
            }
          </span>
        </div>
        <div className="ticket-card">
          <span className="ki">Closed Tickets:</span>
          <span className="ki">
            {
              closedTickets.filter((ticket) =>
                userDetails.role === "cmanager"
                  ? ticket.client_id?.toString() ===
                    userDetails.clientid?.toString()
                  : true
              ).length
            }
          </span>
        </div>
      </div>

      {/* tickets track */}
      <div className="parent-container">
        <h2 className="retick">Search by Ticket Number...</h2>
        <div className="search-container">
          <input
            type="text"
            placeholder="Search by Ticket Number"
            value={ticketNumber}
            onChange={(e) => setTicketNumber(e.target.value)}
          />
          <button
            className="sebtn"
            onClick={() => (handleTicketTrack(), setPopupvalue("ticketFound"))}
          >
            <FaSearchengin />
          </button>
        </div>
      </div>

      {popupvalue === "ticketFound" &&
        Object.keys(searchedTicket).length > 0 && (
          <motion.div
            className="popup-overlay"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="ticket-details-container">
              <div className="ticket-details1">
                <div className="pop1">
                  <div className="Ticket-popup-content">
                    <h2 className="retick">Ticket Details</h2>
                    <div className="ticket-detail">
                      <span className="label1">Ticket Number: </span>
                      <span className="label1">
                        {searchedTicket?.ticketnumber}
                      </span>
                    </div>
                    <div className="ticket-detail">
                      <span className="label1">Contact Number: </span>
                      <span className="label1">
                        {searchedTicket?.contact_number}
                      </span>
                    </div>
                    <div className="ticket-detail">
                      <span className="label1">Email: </span>
                      <span className="label1">{searchedTicket?.email}</span>
                    </div>
                    <div className="ticket-detail">
                      <span className="label1">Error Title: </span>
                      <span className="label1">{searchedTicket?.e_title}</span>
                    </div>
                    <div className="ticket-detail">
                      <span className="label1">Error Description: </span>
                      <span className="label1">{searchedTicket?.e_des}</span>
                    </div>
                    <div className="ticket-detail">
                      <span className="label1">file: </span>

                      <span className="label1">
                        <a
                          href={`${process.env.REACT_APP_BASEURL}/apis/uploads/${searchedTicket.files}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-500 underline"
                        >
                          {searchedTicket.files}
                        </a>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="pop2">
                  <div className="status-flow-container">
                    <h2 className="retick">Ticket Status</h2>
                    {statusFlow.map((status, index) => (
                      <div
                        key={status}
                        className={`status-step ${
                          getStatusIndex(searchedTicket.status) >= index
                            ? "completed"
                            : ""
                        }`}
                      >
                        <div className="status-step-background" />
                        <div className="status-step-text">{status}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {searchedTicket && (
                <motion.div
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8 }}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "end",
                  }}
                >
                  {/* Close Button */}
                  <button
                    className="clsbtn"
                    onClick={() => {
                      setPopupvalue(false);
                      setTicketNumber("");
                    }}
                  >
                    &times;
                  </button>
                  <Chatbox
                    searchedTicketId={searchedTicket?.id}
                    status={searchedTicket?.status}
                    ticketclosed={searchedTicket?.close_time}
                    ticketclosedbyname={searchedTicket?.closedby_name}
                  />
                </motion.div>
              )}
            </div>
          </motion.div>
        )}

      {/* opened  */}
      <div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            onClick={() => {
              setIsOpen1(!isOpen1);
              setIsOpen(false);
            }}
            style={{
              background: "grey",
              padding: "8px 16px",
              borderRadius: "5px",
              color: "white",
              cursor: "pointer",
            }}
          >
            PENDING TICKETS
          </button>
        </div>

        <motion.div
          initial={{ height: "auto", opacity: 1 }}
          animate={{ height: isOpen1 ? "auto" : 0, opacity: isOpen1 ? 1 : 0 }}
          transition={{ duration: 0.5 }}
          style={{
            overflow: "hidden",
            background: " #f1f1f2",
            padding: isOpen1 ? "10px" : "0px",
            borderRadius: "5px",
            marginTop: "10px",
          }}
        >
          <div className="tda">
            <div className="tdb">
              <div className="tdc">
                <table border="1" className="tdd">
                  <thead className="tde">
                    <tr>
                      <th className="tdf">S.No</th>
                      <th className="tdf">Type</th>
                      <th className="tdf">Ticket Number</th>
                      <th className="tdf">Error Tittle</th>
                      <th className="tdf">Status</th>
                      <th className="tdf">View</th>
                      <th className="tdh">Category</th>
                      <th className="tdh">Assign</th>
                    </tr>
                  </thead>
                  <tbody className="tdg">
                    {currentRowsOpened.length > 0 ? (
                      currentRowsOpened.map((ticket, index) => (
                        <tr key={ticket.id}>
                          <td className="tdh">
                            {startIndexOpened + index + 1}.
                          </td>
                          <td className="tdh">{ticket.ticket_type}</td>
                          <td className="tdh">{ticket.ticketnumber}</td>
                          <td className="tdh">{ticket.e_title}</td>
                          <td className="tdh">{ticket.status}</td>

                          <td className="tdh">
                            <button
                              className="tdi"
                              onClick={() =>
                                handleViewClick({
                                  Email: ticket.email,
                                  ticketNumber: ticket.ticketnumber,
                                  ticketcreatedtym: ticket.create,
                                  ticketrestym: ticket.res_time,
                                  ph: ticket.ph,
                                  errorDescription: ticket.e_des,
                                  file: ticket.files,
                                  title: ticket.e_title,
                                  ticketId: ticket.id,
                                  status: ticket.status,
                                  res_tym: ticket.res_time,
                                  category: ticket.category,
                                })
                              }
                            >
                              View
                            </button>
                          </td>
                          <td className="tdh">
                            {ticket.category !== "" ? (
                              ticket.category
                            ) : (
                              <select
                                className="custom-select"
                                value={ticket.category}
                                onChange={(e) => {
                                  const updatedTickets = tickets.map((t) =>
                                    t.id === ticket.id
                                      ? { ...t, category: e.target.value }
                                      : t
                                  );
                                  setTickets(updatedTickets);
                                }}
                                required
                              >
                                <option value="" disabled>
                                  Select Category
                                </option>
                                <option value="Salary">Salary</option>
                                <option value="PF">PF</option>
                                <option value="Insurance">Insurance</option>
                                <option value="OT">OT</option>
                                <option value="Offer Letter">
                                  Offer Letter
                                </option>
                                <option value="Releaving">Releaving</option>
                                <option value="KYC">KYC</option>
                                <option value="Others">Others</option>
                              </select>
                            )}
                          </td>

                          <td className="tdh">
                            {ticket.category !== "" && (
                              <>
                                {ticket.asname ? (
                                  <strong>Assigned to - {ticket.asname}</strong>
                                ) : null}
                                <Ticketassign
                                  category={ticket.category}
                                  TicketNumber={ticket.id}
                                  fetchTickets={fetchTickets}
                                  Ticketstore={setTickets}
                                  assignedTo={ticket?.asid}
                                  assign={ticket?.asname}
                                  selectedticketno={ticket.ticketnumber}
                                />
                              </>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="tdh">
                          No tickets available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {totalPagesOpened > 1 && (
              <div className="tdj">
                <div>
                  <h2 className="tdk">
                    Page {currentPageOpened} of {totalPagesOpened}
                  </h2>

                  <div className="tdl">
                    {currentPageOpened !== 1 && (
                      <>
                        <button
                          className="tdm"
                          onClick={() => setCurrentPageOpened(1)}
                        >
                          &laquo; First page
                        </button>

                        <button
                          className="tdm"
                          onClick={() =>
                            setCurrentPageOpened((prev) =>
                              Math.max(prev - 1, 1)
                            )
                          }
                        >
                          &lt; Previous
                        </button>
                      </>
                    )}

                    {currentPageOpened !== totalPagesOpened && (
                      <>
                        <button
                          className="tdn"
                          onClick={() =>
                            setCurrentPageOpened((prev) =>
                              Math.min(prev + 1, totalPagesOpened)
                            )
                          }
                        >
                          Next &gt;
                        </button>

                        <button
                          className="tdo"
                          onClick={() => setCurrentPageOpened(totalPagesOpened)}
                        >
                          Last page &raquo;
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}

            {isModalOpen && selectedRow && (
              <div className="tdp">
                <div className="tdr">
                  <div className="tds">
                    <h2 className="tdt">Ticket Details</h2>
                    <div className="tdu">
                      <p className="tdv">
                        <strong className="tdw">Ticket Number:</strong> <br />
                        {selectedRow.ticketNumber}
                      </p>
                      <div className="ticket-time-badges">
                        <div className="time-badge">
                          <span className="time-label">Ticket Created:</span>
                          <span className="time-value">
                            {selectedRow.ticketcreatedtym}
                          </span>
                        </div>
                        <div className="time-badge">
                          {["Hold", "Opened"].includes(selectedRow?.status) && (
                            <>
                              <span className="time-label">Ticket Opened:</span>
                              <span className="time-value">
                                {selectedRow.res_tym ===
                                  "0000-00-00 00:00:00" || !selectedRow.res_tym
                                  ? "-"
                                  : selectedRow.res_tym}
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                      <p>
                        <strong className="tdw">Email:</strong> <br />
                        {selectedRow.Email}
                      </p>
                      <p className="tdv">
                        <strong className="tdw">Contact Number:</strong> <br />
                        {selectedRow.ph}
                      </p>
                      <p className="tdv">
                        <strong className="tdw">Error Title:</strong> <br />
                        {selectedRow.title}
                      </p>
                      <p className="tdv">
                        <strong className="tdw">Error Description:</strong>{" "}
                        <br />
                        {selectedRow.errorDescription}
                      </p>
                      <p className="tdv">
                        <strong className="tdw">File:</strong> <br />
                        <a
                          href={`${process.env.REACT_APP_BASEURL}/apis/uploads/${selectedRow.file}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-500 underline"
                        >
                          {selectedRow.file}
                        </a>
                      </p>
                    </div>

                    <div className="tdx">
                      {/* {selectedRow?.category ? (
                        <> */}
                      {selectedRow?.status === "Hold" ? (
                        <button
                          className="tdz"
                          onClick={() => handlestatus("Closed")}
                        >
                          Closed
                        </button>
                      ) : (
                        <>
                          <button
                            className="tdy"
                            onClick={() => handlestatus("Hold")}
                          >
                            Hold
                          </button>
                          <button
                            className="tdz"
                            onClick={() => handlestatus("Closed")}
                          >
                            Closed
                          </button>
                        </>
                      )}
                      {/* </> */}
                      {/* ) : null} */}
                    </div>
                  </div>
                  <div>
                    <Chatbox
                      selectedRowID={selectedRow.ticketId}
                      selectedEmail={selectedRow.Email}
                      status={selectedRow.status}
                      ticketclosed={selectedRow.closed_time}
                      ticketassign={selectedRow.asname}
                    />
                  </div>
                  <div className="tdq" onClick={closeModal}>
                    &times;
                  </div>
                </div>
              </div>
            )}
          </div>
        </motion.div>
      </div>

      {/* closed  */}
      <div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            onClick={() => {
              setIsOpen(!isOpen);
              setIsOpen1(false);
            }}
            style={{
              background: "grey",
              padding: "8px 16px",
              borderRadius: "5px",
              color: "white",
              cursor: "pointer",
            }}
          >
            CLOSED TICKETS
          </button>
        </div>

        <motion.div
          initial={{ height: "auto", opacity: 1 }}
          animate={{ height: isOpen ? "auto" : 0, opacity: isOpen ? 1 : 0 }}
          transition={{ duration: 0.5 }}
          style={{
            overflow: "hidden",
            background: " #f1f1f2",
            padding: isOpen ? "10px" : "0px",
            borderRadius: "5px",
            marginTop: "10px",
          }}
        >
          <div className="outer">
            <div className="maindiv">
              <div className="tdc">
                <table border="1" className="tdd">
                  <thead className="tde">
                    <tr>
                      <th className="tdf">S.No</th>
                      <th className="tdf">Type</th>
                      <th className="tdf">Ticket Number</th>
                      <th className="tdf">Error Tittle</th>
                      <th className="tdf">Status</th>
                      <th className="tdf">View</th>
                      <th className="tdh">Category</th>
                      <th className="tdf">Action</th>
                    </tr>
                  </thead>
                  <tbody className="tdg">
                    {currentRowsClosed.length > 0 ? (
                      currentRowsClosed.map((ticket, index) => (
                        <tr key={ticket.id}>
                          <td className="tdh">
                            {startIndexClosed + index + 1}.
                          </td>
                          <td className="tdh">{ticket.ticket_type}</td>
                          <td className="tdh">{ticket.ticketnumber}</td>
                          <td className="tdh">{ticket.e_title}</td>
                          <td className="tdh">{ticket.status}</td>

                          <td className="tdh">
                            <button
                              className="tdi"
                              onClick={() =>
                                handleViewClick({
                                  Email: ticket.email,
                                  userId: ticket.user_id,
                                  ticketId: ticket.id,
                                  ticketNumber: ticket.ticketnumber,
                                  ph: ticket.ph,
                                  title: ticket.e_title,
                                  errorDescription: ticket.e_des,
                                  file: ticket.files,
                                  status: ticket.status,
                                  asname: ticket.asname,
                                  closedby_name: ticket.clsname,
                                  create: ticket.create,
                                  res_time: ticket.res_time,
                                  closed_time: ticket.ctime,
                                })
                              }
                            >
                              View
                            </button>
                          </td>
                          <td className="tdh">{ticket.category}</td>
                          <td className="tdh">
                            <button
                              className="tdh-1"
                              onClick={() => handlereopen(ticket.id)}
                            >
                              REOPEN
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="tdh">
                          No tickets available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {totalPagesClosed > 1 && (
              <div className="tdj">
                <div>
                  <h2 className="tdk">
                    Page {currentPageClosed} of {totalPagesClosed}
                  </h2>

                  <div className="tdl">
                    {currentPageClosed !== 1 && (
                      <>
                        <button
                          className="tdm"
                          onClick={() => setCurrentPageClosed(1)}
                        >
                          &laquo; First page
                        </button>

                        <button
                          className="tdm"
                          onClick={() =>
                            setCurrentPageClosed((prev) =>
                              Math.max(prev - 1, 1)
                            )
                          }
                        >
                          &lt; Previous
                        </button>
                      </>
                    )}

                    {currentPageClosed !== totalPagesClosed && (
                      <>
                        <button
                          className="tdn"
                          onClick={() =>
                            setCurrentPageClosed((prev) =>
                              Math.min(prev + 1, totalPagesClosed)
                            )
                          }
                        >
                          Next &gt;
                        </button>

                        <button
                          className="tdo"
                          onClick={() => setCurrentPageClosed(totalPagesClosed)}
                        >
                          Last page &raquo;
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}

            {isModalOpen && selectedRow && (
              <div className="tdp">
                <div className="tdr">
                  <div className="tds">
                    <h2 className="tdt">Ticket Details</h2>
                    <div className="tdu">
                      <p className="tdv">
                        <strong className="tdw">Ticket Number:</strong> <br />
                        {selectedRow.ticketNumber}
                      </p>
                      <div className="ticket-time-badges">
                        <div className="time-badge">
                          <span className="time-label">Ticket Created:</span>
                          <span className="time-value">
                            {selectedRow.create}
                          </span>
                        </div>
                        <div className="time-badge">
                          <span className="time-label">Ticket Opened:</span>
                          <span className="time-value">
                            {selectedRow.ticketrestym ===
                              "0000-00-00 00:00:00" || !selectedRow.res_time
                              ? "-"
                              : selectedRow.res_time}
                          </span>
                        </div>
                      </div>
                      <p>
                        <strong className="tdw">Email:</strong> <br />
                        {selectedRow.Email}
                      </p>
                      <p className="tdv">
                        <strong className="tdw">Contact Number:</strong> <br />
                        {selectedRow.ph}
                      </p>
                      <p className="tdv">
                        <strong className="tdw">Error Title:</strong> <br />
                        {selectedRow.title}
                      </p>
                      <p className="tdv">
                        <strong className="tdw">Error Description:</strong>
                        <br /> {selectedRow.errorDescription}
                      </p>
                      <p className="tdv">
                        <strong className="tdw">File:</strong> <br />
                        <a
                          href={`${process.env.REACT_APP_BASEURL}/apis/uploads/${selectedRow.file}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-500 underline"
                        >
                          {selectedRow.file}
                        </a>
                      </p>
                    </div>
                    <div className="tdx">
                      {/* <button className="tdy">Hold</button> */}
                      {/* <button className="tdz">Closed</button> */}
                    </div>
                  </div>
                  <div>
                    <Chatbox
                      selectedRowID={selectedRow.ticketId} // OR searchedTicketId="TIC-2025-00123"
                      selectedEmail={selectedRow.Email}
                      status={selectedRow.status}
                      ticketclosed={selectedRow.closed_time}
                      ticketclosedbyname={selectedRow.closedby_name}
                      userId={selectedRow.userId}
                    />
                  </div>
                  <div className="tdq" onClick={closeModal}>
                    &times;
                  </div>
                </div>
              </div>
            )}
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default Ticketdashboard;
